// extracted by mini-css-extract-plugin
export default {"formGroup":"styles_formGroup__umJRl","label":"styles_label__MLMQ3","input":"styles_input__CwEBO"};